import React, { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router-dom'

import { announceStoredGoogleConsent } from '@leanpay/utils'

import { currentEnvironment, currentMarket, gtmId, isProdEnvironment } from 'library/constants'

import '@leanpay/ui/main.css'

import App from './app'

import './index.css'

import { initI18n } from './i18n'

Sentry.init({
    dsn: 'https://e823fdf9544089bc6ed1ca61e37a27e4@o4508023659560960.ingest.de.sentry.io/4508042185277520',
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration(),
    ],
    enabled: true,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: currentEnvironment.toLowerCase(),
    ignoreErrors: [
        'Non-Error promise rejection captured with value: VENDOR_API_TOKEN_UNKNOWN',
        'Non-Error promise rejection captured with value: 502',
        'Failed to fetch dynamically imported module',
        'Network Error',
        "Can't find variable: gmo",
        'Fetch request to',
        'The object can not be cloned',
    ],
})
Sentry.setTag('market', currentMarket.toLowerCase())

if (isProdEnvironment) {
    const tagManagerArgs = {
        gtmId,
    }

    TagManager.initialize(tagManagerArgs)
    announceStoredGoogleConsent()
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find the root element')

// Initialize i18n before rendering
initI18n().then(() => {
    ReactDOM.createRoot(rootElement).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    )
})
